import * as React from 'react';
import { observer } from 'mobx-react';
import { ExperienceResource } from '../../../../../../../../../../../../Types';
import { findLink } from '../../../../../../../../../../../../../../LinkyLinky';
import ExternalLink from '../../../../../../../../../../../../../ExternalLink';
import { T } from '../../../../../../../../../../../../../../Translations';
import DownloadIcon from '../../../../../../../../../../../../../Cutesies/DownloadIcon';

export interface Props {
  resource: ExperienceResource;
}

const OverviewPdfLink: React.FC<Props> = ({ resource }) =>
  findLink('download-overview-pdf', resource.links)
    .map((link) => (
      <ExternalLink href={link.href}>
        <div className="flex text-sm">
          <span className="mr-3">
            <T kind="Download Overview" />
          </span>
          <span className="flex items-center">
            <DownloadIcon />
          </span>
        </div>
      </ExternalLink>
    ))
    .getOrElse(() => <></>);

export default observer(OverviewPdfLink);
